// extracted by mini-css-extract-plugin
export default {"content":"vRE0kOdbkGJkaeoOO4eR"};